import script from "./Ticket.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ticket.vue?vue&type=script&setup=true&lang=ts"

import "./Ticket.vue?vue&type=style&index=0&id=2c74a5f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c74a5f8"]])

export default __exports__